import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import SEO from "@/components/SEO";

export default function MagazinesPage() {
  const [mags, setMags] = useState([]);
  useEffect(() => { api.get("/magazines").then((r) => setMags(r.data || [])).catch(() => {}); }, []);

  const featured = mags.find((m) => m.featured);
  const rest = mags.filter((m) => !m.featured);

  return (
    <div className="pt-32 md:pt-40 max-w-[1400px] mx-auto px-5 md:px-10 min-h-screen">
      <SEO title="Revistas" description="Nuestra colección de ediciones digitales. Sumérgete en cada número." />
      <header className="mb-16 text-center">
        <p className="kicker text-sunset-accent mb-4">Ediciones Digitales</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight">Revistas</h1>
        <p className="text-sunset-muted max-w-xl mx-auto mt-5">Nuestra colección de ediciones digitales. Sumérgete en cada número directamente en Issuu.</p>
      </header>

      {featured && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-24">
          <motion.a href={featured.issuu_url} target="_blank" rel="noopener noreferrer"
            data-testid="magazine-featured" whileHover={{ rotateY: 6, rotateX: -3 }}
            style={{ transformStyle: "preserve-3d", perspective: 1000 }}
            className="block aspect-[3/4] bg-sunset-border overflow-hidden shadow-2xl mx-auto max-w-md">
            <img src={mediaUrl(featured.cover_image)} alt={featured.title} className="w-full h-full object-cover" />
          </motion.a>
          <div>
            <p className="kicker text-sunset-accent mb-3">Edición Destacada · {featured.edition}</p>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight mb-5">{featured.title}</h2>
            <p className="text-sunset-muted leading-relaxed mb-8">{featured.description}</p>
            <a href={featured.issuu_url} target="_blank" rel="noopener noreferrer" data-testid="magazine-read-featured"
              className="group inline-flex items-center gap-3 bg-sunset-ink text-white kicker px-9 py-4 hover:bg-sunset-accent transition-colors">
              Leer edición <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14 pb-8">
        {rest.map((m, i) => (
          <motion.div key={m.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6, delay: (i % 3) * 0.08 }} className="group">
            <a href={m.issuu_url} target="_blank" rel="noopener noreferrer" data-testid={`magazine-cover-${m.id}`}
              className="block aspect-[3/4] bg-sunset-border overflow-hidden img-zoom shadow-lg mb-5">
              <img src={mediaUrl(m.cover_image)} alt={m.title} className="w-full h-full object-cover" />
            </a>
            <p className="kicker text-sunset-accent mb-2">{m.edition} · {m.date}</p>
            <h3 className="font-serif text-2xl tracking-tight mb-2">{m.title}</h3>
            <p className="text-sunset-muted text-sm line-clamp-2 mb-4">{m.description}</p>
            <a href={m.issuu_url} target="_blank" rel="noopener noreferrer"
              className="kicker border-b border-sunset-ink pb-1 hover:text-sunset-accent hover:border-sunset-accent transition-colors">Leer edición</a>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
